/* istanbul ignore file */

export const REQUIRED_COPY = 'Required';
export const UPPERCASE_NOTICE_COPY = 'All letters will be uppercase on finished item';
export const LOWERCASE_NOTICE_COPY = 'All letters will be lowercase on finished item';

export const CONTENT_LABEL = 'Product personalisation options';

export const REQUIRED_SELECTION_COPY = "You haven't made a selection";
export const REQUIRED_INPUT_COPY = "You haven't entered any text";
export const MAX_CHARACTERS_COPY = "You're over the character count limit";
export const TOGGLE_BUTTON_GROUP_DESCRIPTION = 'Only one option can be selected';
export const NO_EMOJIS_ALLOWED_COPY = 'Sorry, emojis are not supported';
export const IMAGE_CHOOSE_COPY = 'Choose photos';
export const REQUIRED_IMAGE_COPY = 'Please add the required photos';
